import { useRef, type FocusEvent, type MouseEvent } from 'react'

/**
 * Focusing a small value field selects what it holds, so typing replaces it — appending to
 * "3" to get "34" is never what anyone meant. The mouse-up that follows a click would collapse
 * the selection again, so the first one after focusing is swallowed.
 */
export function useSelectOnFocus() {
  const fresh = useRef(false)
  return {
    onFocus: (event: FocusEvent<HTMLInputElement>) => {
      fresh.current = true
      event.currentTarget.select()
    },
    onMouseUp: (event: MouseEvent<HTMLInputElement>) => {
      if (fresh.current) {
        fresh.current = false
        event.preventDefault()
      }
    },
  }
}
